import entity from '../../../models/mlm/members'

export default [
  {
    path: '/members',
    meta: {
      entity,
      requiresPermissionTo: 'members',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/members/new',
    meta: {
      entity,
      requiresPermissionTo: 'members',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/members/:id',
    meta: {
      entity,
      requiresPermissionTo: 'members',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
